import { Button } from '@wix/design-system';
import { ArrowDown } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './ExploreSimilarButton.scss';
export const ExploreSimilarButton = _ref => {
  let {
    visible,
    onClick
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const label = t('domain_search_gate.whois_results.mobile.suggestions_card.subtitle');
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": "whois-explore-cta",
    className: `${s.wrapper} ${visible ? s.visible : ''}`
  }, /*#__PURE__*/React.createElement(Button, {
    className: s.button,
    size: "medium",
    skin: "dark",
    priority: "primary",
    suffixIcon: /*#__PURE__*/React.createElement(ArrowDown, null),
    onClick: onClick,
    "aria-label": label
  }, label));
};
//# sourceMappingURL=ExploreSimilarButton.js.map